import React from 'react';

export const TermsAndConditions = ({ size = 18, ...rest }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="#FEB45F" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20 4V20H5.50002V14.9278L2.57458 12.0024L5.50002 9.07698V4H20ZM18.5 5.5H7.00002V9.6983L4.6959 12.0024L7.00002 14.3065V18.5H18.5V5.5Z" fill="#FEB45F"/>
        <path d="M13.5 16H12V9.5H9.50002V8H16V9.5H13.5V16Z" fill="#FEB45F"/>
        </svg>
    );
};